<template>
  <div class="row mx-0" id="admin-dashboards-goals">
    <div class="col-12 mt-3">
      <span class="h4">Alterações realizadas hoje </span>
      <span class="pl-2">{{ loading ? 'Carregando...' : '' }}</span>
    </div>
    <div class="col-12 d-flex">
      <div class="col-4 form-group">
        <product_multiselect
          ref="preferredProductsMultiselect"
          label="Produto"
          v-model="filter.product"
          :multiple="true" 
          :closeOnSelect="false"  
        />
      </div>
      <div class="col-4 form-group">
        <label class="form-control-label">Grupo</label><br>
        <multiselect
          v-model="filter.group"
          :options="groups"
          label="descricao"
          track-by="id"
          :preserveSearch="true"
          :showNoResults="false"
          placeholder="Selecionar grupo"
          :selected-label="'Selecionado'"
          :loading="loadingGroup"
          :multiple="true"
          :limit="1"
          :limit-text="limitText"
        />
      </div>
      <div class="col-4 form-group">
        <label class="form-control-label">Período (De/Até)</label><br>
        <DatePicker
          v-model="filter.startEndDate"
          type="daterange"
          range-separator="-"
          :editable="false"
          start-placeholder="Data início"
          end-placeholder="Data fim"
          unlink-panels
          prefix-icon="fa fa-calendar"
          format="d 'de' MMMM 'de' yyyy">
        </DatePicker>
      </div>
    </div>
    <div class="col-12 d-flex justify-content-end">
      <div class="cols-12" style="padding: 1rem">
        <base-button @click="clearFilters" color="green" type="neutral" class="mr-3">Limpar Filtros</base-button>
        <base-button @click="applyFilters" type="primary">Aplicar Filtro</base-button>
      </div>
    </div>
    <div class="col-12 col-md-6 p-0">
      <div class="row p-0">
        <div class="col-12 p-0 px-3">
          <div class="card card-flat m-3 p-3" style="height: 124px;">
            <div class="row">
              <div class="col-6">
                <h4 class="card-title text-uppercase text-muted m-0">META FINANCEIRA</h4>
                <p class="h4 font-weight-bold m-0">{{ (totalvalues.meta_financeira || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl', minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
              </div>
              <div class="col-6">
                <h4 class="card-title text-uppercase text-muted m-0">META ESTRATEGICA</h4>
                <p class="h4 font-weight-bold m-0">{{ (totalvalues.meta_estrategica || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl', minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
              </div>
              <div class="col-6">
                <h4 class="card-title text-uppercase text-muted m-0">META FORNECEDOR</h4>
                <p class="h4 font-weight-bold m-0">{{ (totalvalues.meta_fornecedor || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl', minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
              </div>
            </div>
          </div>
        </div>
    
        <div class="col-12 p-0 px-3">
          <div class="card card-flat m-3" style="height: calc(60vh - 124px); position: relative">
            <Table
              :data="goalsChanges"
              class="table-responsive table-striped"
              header-row-class-name="thead-light"
              height="100%"
              style="min-width: 100%; overflow: visible;"
            >
              <TableColumn width="27px" v-slot="{ row }">
                <div class="pl-2">
                  <alert-badge :alerts="row.alerts" />
                </div>
              </TableColumn>
              <TableColumn label="Vendedor" prop="salesman_name" width="250px" sortable v-slot="{ row }">
                <div class="px-2">
                  <span>{{ row.salesman_name }}</span>
                </div>
              </TableColumn>
              <TableColumn label="Volume" prop="changes.volume" width="160px" sortable v-slot="{ row }">
                <i class="fa fa-arrow-down text-red" v-if="row.changes.volume < 0"></i>
                <i class="fa fa-arrow-up text-success" v-else-if="row.changes.volume > 0"></i>
                {{ (row.changes.volume || 0).toLocaleString('pt-BR') }}
              </TableColumn>
              <TableColumn label="Meta" prop="meta_financeira" width="160px" sortable v-slot="{ row }">
                {{ (row.meta_financeira || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl', minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
              </TableColumn>
              <TableColumn label="Variação da Meta" prop="changes.valor_meta" width="160px" sortable v-slot="{ row }">
                <i class="fa fa-arrow-down text-red" v-if="row.changes.valor_meta < 0"></i>
                <i class="fa fa-arrow-up text-success" v-else-if="row.changes.valor_meta > 0"></i>
                {{ (row.changes.valor_meta || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl', minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
              </TableColumn>
              <TableColumn label="Vol Estratégico" prop="changes.volume_estrategico" width="160px" sortable v-slot="{ row }">
                <i class="fa fa-arrow-down text-red" v-if="row.changes.volume_estrategico < 0"></i>
                <i class="fa fa-arrow-up text-success" v-else-if="row.changes.volume_estrategico > 0"></i>
                {{ (row.changes.volume_estrategico || 0).toLocaleString('pt-BR') }}
              </TableColumn>
              <TableColumn label="Meta Estratégica" prop="meta_estrategica" width="160px" sortable v-slot="{ row }">
                {{ (row.meta_estrategica || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl', minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
              </TableColumn>
              <TableColumn label="Variação da Meta Estratégica" prop="changes.valor_estrategico" width="160px" sortable v-slot="{ row }">
                <i class="fa fa-arrow-down text-red" v-if="row.changes.valor_estrategico < 0"></i>
                <i class="fa fa-arrow-up text-success" v-else-if="row.changes.valor_estrategico > 0"></i>
                {{ (row.changes.valor_estrategico || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'brl', minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
              </TableColumn>
            </Table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 p-0">
      <div class="card card-flat m-3">
        <div class="row p-0 mx-4 mb-2 mt-2">
          <div class="mb-3">
            <span class="h2">Histórico de Versões</span>
            <i v-show="loadingVersions" class="fas fa-circle-notch fa-spin ml-1"></i>
          </div>
          <div class="col-auto align-items-center ml-auto mb-3">
            <base-button 
              color="red"
              type="neutral"
              @click="versionsGeneratePdf()"
              class="btn btn-outline text-red btn-sm mr-2"
              v-loading="isLoadingPdfDownload">Gerar PDF <i class="fa fa-file-pdf"></i>
            </base-button>
            <base-button 
              color="green"
              type="neutral"
              @click="versionsGenerateExcel()"
              class="btn btn-outline text-green btn-sm"
              v-loading="isLoadingExcelDownload">Gerar Excel<i class="fa fa-file-excel"></i>
            </base-button>
          </div>
          <div class="">
            <div class="btn-group mr-2">
              <base-button :outline="!versionsFilter.withGoal"             @click="versionsFilter.withGoal = !versionsFilter.withGoal" type="primary" size="sm">METAS</base-button>
              <base-button :outline="!versionsFilter.withPreferredproduct" @click="versionsFilter.withPreferredproduct = !versionsFilter.withPreferredproduct" type="primary" size="sm">PRODUTOS PREFERENCIAIS</base-button>
            </div>
            <div class="btn-group">
              <base-button :outline="!versionsFilter.withCreation" @click="versionsFilter.withCreation = !versionsFilter.withCreation" type="primary" size="sm">CRIAÇÃO</base-button>
              <base-button :outline="!versionsFilter.withUpdate"   @click="versionsFilter.withUpdate = !versionsFilter.withUpdate" type="primary" size="sm">EDIÇÃO</base-button>
              <base-button :outline="!versionsFilter.withDelete"   @click="versionsFilter.withDelete = !versionsFilter.withDelete" type="primary" size="sm">EXCLUSÃO</base-button>
            </div>
          </div>
        </div>
        <version-list 
          :versions="versions" 
          style="height: calc(60vh - 16px); overflow-y: auto; overflow-x: hidden;"
          @bottom-reached="getNextPageVersions"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, onUnmounted, watch, onMounted } from 'vue';

import VersionList from "@/components/Versions/VersionList.vue";
import axios from "@/backend/axios/index.js";
import bellSound from "@/assets/sound/wooden-bell.wav"
import {  DatePicker } from "element-ui";
import { Table, TableColumn } from "element-ui";
import AlertBadge from '@/components/Alerts/AlertBadge.vue';
import product_multiselect from '../../../components/Multiselect/product_multiselect.vue';
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

const UPDATE_INTERVAL = 30000;
const isInterval = ref(false)
const hasMoreVersions = ref(false)
const versionPageNumber = ref([])
const goalsChanges = ref([]);
const playedAlerts = ref([]);
const loading = ref(false);
const versionsPage = ref(1);

const START_DATE_OPTIONS = [
  {
    label: "Hoje",
    value: new Date().toISOString().split("T")[0],
  },
  {
    label: "Ontem",
    value: new Date(Date.now() - 86400000).toISOString().split("T")[0],
  },
  {
    label: "Últimos 7 dias",
    value: new Date(Date.now() - 604800000).toISOString().split("T")[0],
  },
  {
    label: "Últimos 30 dias",
    value: new Date(Date.now() - 2592000000).toISOString().split("T")[0],
  },
]
const startDate = ref(START_DATE_OPTIONS[0]);

const playBellSound = () => {
  const audio = new Audio(bellSound);
  audio.play();
};

const detectNewAlerts = () => {
  const newAlerts = goalsChanges.value.filter(change => !playedAlerts.value.includes(change.salesman_id));
  playedAlerts.value = goalsChanges.value.map(change => change.salesman_id);
  return newAlerts;
};

const limitText = (count) => {
  return `+ ${count}`;
};

onMounted(() => {
  loadGrupos();
});

const loadingGroup = ref(false)
const groups = ref([]);
const allGroupsSelected = ref(false)

const loadGrupos = async () => {
  loadingGroup.value = true
  try {
    const response = await axios.get("/api/v1/grupos");
    groups.value = response.data;
  } catch (error) {
    console.error("Erro ao carregar grupos:", error);
  } finally {
    loadingGroup.value = false
  }
};

const filter = ref({
  product: [],
  group: null,
  startEndDate: []
})

const filterVersions = () => {
  const params = {};

  const itemTypes = [];

  if (versionsFilter.value.withGoal)             itemTypes.push("Goal");
  if (versionsFilter.value.withPreferredproduct) itemTypes.push("Preferredproduct");

  const events = [];
  if (versionsFilter.value.withCreation) events.push("create");
  if (versionsFilter.value.withUpdate)   events.push("update");
  if (versionsFilter.value.withDelete)   events.push("destroy");

  params["version[item_type]"] = itemTypes;
  params["version[event]"] = events;
  params["version[start_date]"] = startDate.value.value;


  if (filter.value.startEndDate.length === 2) {
    const [startDate, endDate] = filter.value.startEndDate;
    
    const formattedStartDate = startDate.toISOString().split('T')[0];
    const formattedEndDate = endDate.toISOString().split('T')[0];

    params["version[start_date]"] = [formattedStartDate];
    params["version[end_date]"] = [formattedEndDate];
  }

  if (filter.value.product && filter.value.product.length > 0) {
    params["version[preferredproduct_id]"] = filter.value.product.map((product) => product.id);
  }

  if (filter.value.group && filter.value.group.length > 0) {
    params["version[group_id]"] = filter.value.group.map((group) => group.id);
  }
  
  return params;
}

const clearFilters = async () => {
  const allFieldsEmpty = !filter.value.product && !filter.value.group && filter.value.startEndDate.length === 0;

  if (allFieldsEmpty) return

  filter.value.product = []
  filter.value.group = null
  filter.value.startEndDate = []
  versionsPage.value = 1
  await getVersions()
}

const isLoadingPdfDownload = ref(false)
const isLoadingExcelDownload = ref(false)

const versionsGenerateExcel = async () => {
  isLoadingExcelDownload.value = true;
  
  const params = {
    ...filterVersions(),
  };

  if (!params["version[item_type]"].length) {
    isLoadingExcelDownload.value = false;
    return;
  }

  try {
    const response = await axios.get('/api/v1/admin/versions.xlsx', {
      params,
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `versoes_${new Date().toISOString()}.xlsx`);
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  } catch (error) {
    console.error('Erro ao gerar o Excel:', error);
  } finally {
    isLoadingExcelDownload.value = false;
  }
};


const versionsGeneratePdf = async () => {
  isLoadingPdfDownload.value = true;

  const params = {
    ...filterVersions()
  };

  if (!params["version[item_type]"].length) {
    isLoadingPdfDownload.value = false;
    return;
  }

  try {
    const response = await axios.get('/api/v1/admin/versions.pdf', {
       params,
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `versoes_${new Date().toISOString()}.pdf`);
    document.body.appendChild(link);
    link.click();
    
    document.body.removeChild(link);
  } catch (error) {
    console.error('Erro ao gerar o PDF:', error);
  } finally {
    isLoadingPdfDownload.value = false;
  }
}

const getGoalsChanges = async () => {
  const response = await axios.get("/api/v1/system_administration/goals_changes_by_salesman", { params: {
    since: startDate.value.value,
  }})
  goalsChanges.value = response.data.data || [];
  detectNewAlerts().forEach(playBellSound);
};

const totalvalues = ref({});

const getTotalValues = async () => {
  const response = await axios.get("/api/v1/totalvalues", { params: { salesman_id: 0 } })
  totalvalues.value = response.data || {};
};

const versions = ref([]);
const loadingVersions = ref(false);
const versionsRequestIndex = ref(0);
const versionsFilter = ref({
  withGoal: true,
  withPreferredproduct: true,
  withCreation: true,
  withUpdate: true,
  withDelete: true,
});

const getNextPageVersions = () => {
  if (loadingVersions.value || versionsPage.value === versionPageNumber.value) return
  
  versionsPage.value += 1;

  getVersions(true);
}

const getVersions = async (concatResult = false) => {
  loadingVersions.value = true;

  versionsRequestIndex.value += 1;
  const currentRequestIndex = versionsRequestIndex.value;

  const params = {
    ...filterVersions(),
    page: versionsPage.value,
    per_page: 100,
  };

  if (params.page > versionPageNumber.value) params.page = versionPageNumber.value

  if (!isInterval.value && !concatResult) versions.value = []

  if (!params["version[item_type]"].length) {
    loadingVersions.value = false;
    versions.value = [];
    return;
  }

  const response = await axios.get('/api/v1/admin/versions', { params })

  versionPageNumber.value = response.data.pages

  if (currentRequestIndex !== versionsRequestIndex.value) return;

  if (!response.data.versions.length) return

  if (concatResult) { 
    versions.value = versions.value.concat(response.data.versions || []);
  } else {
    versions.value = response.data.versions || []; 
  }

  loadingVersions.value = false;
};

const getData = async () => {
  loading.value = true;
  
  let promisses = [
    getGoalsChanges(),
    getTotalValues(),
  ]

  if (versionsPage.value == 1) promisses.push(getVersions())

  try {
    await Promise.all(promisses);
  } catch (error) {
    console.error("[getData]", error);
  } finally {
    loading.value = false;
  }
};

const handleGetVersions = () => {
  puller.value = setInterval(() => {
    isInterval.value = true;
    if (versionsPage.value >= versionPageNumber.value) return;
    getVersions();
  }, UPDATE_INTERVAL);
};

const applyFilters = () => {
  isInterval.value = false;
  versionsPage.value = 1
  getVersions();
};

watch(versionsFilter, () => {
  versionsPage.value = 1;
  getVersions();
}, { deep: true });

const puller = ref()

onBeforeMount(() => {
  getData()
  handleGetVersions()
});

onUnmounted(() => {
  clearInterval(puller.value);
});
</script>

<style>
#admin-dashboards-goals .el-table__body-wrapper ul.dropdown-menu {
  position: fixed !important;
  top: 30%;
}

#admin-dashboards-goals .table-responsive {
  transform: translate(0, 0);
}

</style>
